export enum EventTypeEnum {
    // Tracking events
    STOPPED = 'STOPPED',
    ZONE_SPEED_VIOLATION = 'ZONE_SPEED_VIOLATION',
    INSTANT_SPEED_VIOLATION = 'INSTANT_SPEED_VIOLATION',
    LONGTERM_SPEED_VIOLATION = 'LONGTERM_SPEED_VIOLATION',
    GPS_SIGNAL_LOST = 'GPS_SIGNAL_LOST', // integration tracker lost GPS signal (poor satellite count); duration is set when the signal is regained
    CORRUPT_FRAME = 'CORRUPT_FRAME', // trama corrupta: tracker kept reporting but every position was discarded by GPS validation; duration is set when a valid position arrives

    // Tachograph events
    TACHOGRAPH_STATUS_CHANGE = 'TACHOGRAPH_STATUS_CHANGE',
    DRIVER_START_DRIVING = 'DRIVER_START_DRIVING',
    DRIVER_START_WORKING = 'DRIVER_START_WORKING',
    DRIVER_START_RESTING = 'DRIVER_START_RESTING',
    DRIVER_START_AVAILABLE = 'DRIVER_START_AVAILABLE',
    DRIVER_GOES_ERROR = 'DRIVER_GOES_ERROR',
    DRIVER_GOES_NOT_AVAILABLE = 'DRIVER_GOES_NOT_AVAILABLE',

    // Mobile app events
    OFF_DUTY = 'OFF_DUTY', // fuera de servicio
    ON_DUTY = 'ON_DUTY', // en servicio
    GPS_ON = 'GPS_ON', // GPS encendido
    GPS_OFF = 'GPS_OFF', // GPS apagado
    LOW_BATTERY = 'LOW_BATTERY', // batería baja
    BATTERY_OKAY = 'BATTERY_OKAY', // batería ok
    LOCATION_PERMISSION_DENIED = 'LOCATION_PERMISSION_DENIED', // permiso de ubicación denegado
    SERVICE_STARTED = 'SERVICE_STARTED', // servicio iniciado
    SERVICE_STOPPED = 'SERVICE_STOPPED', // servicio detenido
    LOCATION_ERROR = 'LOCATION_ERROR', // error de ubicación
    // prioridad baja
    NETWORK_CONNECTED = 'NETWORK_CONNECTED', // red conectada
    NETWORK_DISCONNECTED = 'NETWORK_DISCONNECTED', // red desconectada
    SYNC_ERROR = 'SYNC_ERROR', // error de sincronización
}
